{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Sækja",
      "UPLOADING": "Hleður upp..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Senda"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Endursenda skilaboð",
      "ERROR_MESSAGE": "Tókst ekki að senda skilaboðin, reyndu aftur"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Not available"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Við erum tengd",
    "OFFLINE": "Það er enginn við í augnablikinu",
    "BACK_AS_SOON_AS_POSSIBLE": "We will be back as soon as possible"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Svarar iðulega innan nokkura mínútna",
    "IN_A_FEW_HOURS": "Svarar iðulega innan nokkura klukkustunda",
    "IN_A_DAY": "Svarar iðulega samdægurs",
    "BACK_IN_HOURS": "We will be back online in {n} hour | We will be back online in {n} hours",
    "BACK_IN_MINUTES": "We will be back online in {time} minutes",
    "BACK_AT_TIME": "We will be back online at {time}",
    "BACK_ON_DAY": "We will be back online on {day}",
    "BACK_TOMORROW": "We will be back online tomorrow",
    "BACK_IN_SOME_TIME": "We will be back online in some time"
  },
  "DAY_NAMES": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "START_CONVERSATION": "Hefja samtal",
  "END_CONVERSATION": "Ljúka samtali",
  "CONTINUE_CONVERSATION": "Halda samtali áfram",
  "YOU": "You",
  "START_NEW_CONVERSATION": "Hefja nýtt samtal",
  "VIEW_UNREAD_MESSAGES": "You have unread messages",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Sjá nýjustu skilaboð",
    "CLOSE_MESSAGES_BUTTON": "Loka",
    "COMPANY_FROM": "frá",
    "BOT": "Spjallmenni"
  },
  "BUBBLE": {
    "LABEL": "Spjallaðu við okkur"
  },
  "POWERED_BY": "Keyrt af Chatwoot",
  "EMAIL_PLACEHOLDER": "Vinsamlegast sláðu inn netfangið þitt",
  "CHAT_PLACEHOLDER": "Skrifaðu skilaboðin hér",
  "TODAY": "Í dag",
  "YESTERDAY": "Í gær",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Fullt nafn",
        "PLACEHOLDER": "Vinsamlegast sláðu inn nafnið þitt",
        "REQUIRED_ERROR": "Það verður að skrifa fullt nafn"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Netfang",
        "PLACEHOLDER": "Vinsamlegast sláðu inn netfangið þitt",
        "REQUIRED_ERROR": "Það verður að skrifa netfang",
        "VALID_ERROR": "Það verður að skrifa gilt netfang"
      },
      "PHONE_NUMBER": {
        "LABEL": "Símanúmer",
        "PLACEHOLDER": "Vinsamlegast sláðu inn símanúmerið þitt",
        "REQUIRED_ERROR": "Það verður að skrifa símanúmer",
        "DIAL_CODE_VALID_ERROR": "Please select a country code",
        "VALID_ERROR": "Please enter a valid phone number",
        "DROPDOWN_EMPTY": "Engar niðurstöður fundust",
        "DROPDOWN_SEARCH": "Search country"
      },
      "MESSAGE": {
        "LABEL": "Skilaboð",
        "PLACEHOLDER": "Vinsamlegast sláðu inn skilaboð",
        "ERROR": "Skilaboðin eru of stutt"
      }
    },
    "CAMPAIGN_HEADER": "Vinsamlegast sláðu inn nafn og netfang áður en samtalið hefst",
    "IS_REQUIRED": "er nauðsynlegt",
    "REQUIRED": "Nauðsynlegt",
    "REGEX_ERROR": "Please provide a valid input"
  },
  "FILE_SIZE_LIMIT": "Skráin fer framyfir hámarksstærð viðhengja ({MAXIMUM_FILE_UPLOAD_SIZE})",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Ógildur reitur"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Leita að emoji",
    "NOT_FOUND": "Enginn emoji fannst",
    "ARIA_LABEL": "Emoji picker"
  },
  "EMOJI_ICON_PICKER": {
    "SEARCH_EMOJI": "Search emoji…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "No emoji match your search"
  },
  "CSAT": {
    "TITLE": "Gefðu samtalinu einkunn",
    "SUBMITTED_TITLE": "Takk fyrir að gefa samtalinu einkunn",
    "PLACEHOLDER": "Segðu okkur meira..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Biðja um afrit af samtalinu",
    "SEND_EMAIL_SUCCESS": "Afritið af samtalinu var sent",
    "SEND_EMAIL_ERROR": "Það kom upp villa, vinsamlegast reyndur aftur"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Smelltu hér til að taka þátt",
      "LEAVE_THE_ROOM": "Yfirgefa símtalið"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Popular Articles",
    "VIEW_ALL_ARTICLES": "View all articles",
    "IFRAME_LOAD_ERROR": "There was an error loading the article, please refresh the page and try again."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Myndaskilaboð"
    },
    "audio": {
      "CONTENT": "Hljóðskilaboð"
    },
    "video": {
      "CONTENT": "Myndbandsskilaboð"
    },
    "file": {
      "CONTENT": "File Attachment"
    },
    "location": {
      "CONTENT": "Staðsetning"
    },
    "fallback": {
      "CONTENT": "hefur deilt vefslóð"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Replying to:"
  }
}
